import React from "react"
import styled from "styled-components"
import Ripples from "react-ripples"

const Button = ({
  children,
  dispatch,
  size,
  fullWidth,
  primary,
  secondary,
  style,
  color,
  className,
  disabled,
}) => {
  return (
    <StyledRipples color="rgba(255, 255, 255, 0.25)">
      <StyledButton
        primary={primary}
        secondary={secondary}
        fullWidth={fullWidth}
        size={size}
        onClick={dispatch}
        style={style}
        color={color}
        className={className}
        disabled={disabled}
      >
        {children}
      </StyledButton>
    </StyledRipples>
  )
}

export default Button

const StyledButton = styled.button`
  background-color: #79b9c0;
  color: #fff;
  border: none;
  border-radius: 3px;
  padding: 15px 30px;
  cursor: pointer;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 22px;
  letter-spacing: 0.5px;
  transition: background-color 50ms ease;
  white-space: nowrap;

  &:hover {
    background-color: #438890;
  }

  &[disabled], &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
  }

  ${props =>
    props.secondary &&
    `
    background-color: #444444;

    &:hover {
      background-color: #4e4e4e;
    }
  `}

  ${props =>
    props.color &&
    props.color === "red" &&
    `
    background-color: #880000;

    &:hover {
      background-color: #981d1d;
    }
  `}

  ${props =>
    props.fullWidth &&
    `
    width: 100%;
  `}

  ${props =>
    props.size === "small" &&
    `
    font-size: 14px;
    padding: 8px 15px 7px 15px;
  `}

  svg {
    float: left;
    ${props =>
      !props.fullWidth &&
      `
        margin-right: 10px;
    `}
  }
`

const StyledRipples = styled(Ripples)`
  display: block !important;
`
